import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=5c49d2c0&scoped=true"
import script from "./Component.vue?vue&type=script&lang=js"
export * from "./Component.vue?vue&type=script&lang=js"
import style0 from "./Component.vue?vue&type=style&index=0&id=5c49d2c0&prod&lang=scss&scoped=true"
import style1 from "./Component.vue?vue&type=style&index=1&id=5c49d2c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c49d2c0",
  null
  
)

export default component.exports